import "@inovua/reactdatagrid-enterprise/index.css";
import { Article, TableView } from "@mui/icons-material";
import {
  AppBar,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  FormLabel,
  Grid,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import React from "react";
import Dropzone from "react-dropzone";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/*----------------------Cac control trong project su dung den trong form----------------*/
import MenuButtons from "../components/MenuButtons";
import MyDateEditor from "../components/MyDateEditor";
import MySelectFilter from "../components/MySelectFilter";
import SimpleDialog from "../components/SimpleDialog";
import { formStyles, handleServerError, showError } from "../components/common";
import FieldNameDialog from "./FieldNameDialog";

/*-----------------------Cac thu vien dung chung -------------------------*/
const myLib = require("../lib/MyLib");
const server = require("../lib/server");
/*-----------------------Cac dinh nghia ----------------------------------*/
const englishUI = true;
/*-----------------------Dinh nghia cac label tieng Anh, tieng Viet su dung trong form*/
const formTitle = englishUI ? "Merger Contractors" : "Gộp nhà thầu";
const fieldLabels_EN = {
  HangMucID: "Repair Items (RI):",
  MaCongTy: "Contractor:",
  GiamDoc: "Director:",
  SoYCCG: "RFQ No:",
  NgayYCCG: "Date:",
  PhongYeuCau: "From department:",
  YeuCau: "Subject:",
  RI: "RI:",
  MoTa: "Description:",
  GhiChu: "Remarks:",
  NguoiDeNghi: "Created by:",
  TruongPhong: "Approved by:",
  Attachs: "Attachs",
  MaCongTy2: "New Contractor:",
};
const fieldLabels_VN = {
  HangMucID: "HMSC:",
  MaCongTy: "Công ty:",
  GiamDoc: "Giám đốc:",
  SoYCCG: "YCCG số:",
  NgayYCCG: "Ngày:",
  PhongYeuCau: "Phòng yêu cầu:",
  YeuCau: "Yêu cầu:",
  RI: "HMSC:",
  MoTa: "Mô tả:",
  GhiChu: "Ghi chú:",
  NguoiDeNghi: "Người đề nghị:",
  TruongPhong: "Người duyệt:",
  Attachs: "Attachs",
  MaCongTy2: "Công ty mới:",
};
const fieldLabels = englishUI ? fieldLabels_EN : fieldLabels_VN;
function getFieldNames() {
  var list = [];
  var keys = Object.keys(fieldLabels);
  for (var i = 0; i < keys.length; i++) {
    list.push({
      FieldName: keys[i],
    });
  }
  return list;
}
const listFields = getFieldNames();
const buttonLabels = englishUI
  ? {
    btnSave: "Save",
    btnClose: "Close",
    btnDownload: "Download",
    btnExport: "Export",
  }
  : {
    btnSave: "Lưu",
    btnClose: "Thoát",
    btnDownload: "Tải file",
    btnExport: "Xuất",
  };

const buttonExports = [
  {
    ID: "Word",
    Form: "TiengAnh",
    Label: "Word - English",
    LabelEN: "Word - English",
    Icon: <Article fontSize="small" />,
  },
  {
    ID: "Word",
    Form: "TiengViet",
    Label: "Word - Tiếng Việt",
    LabelEN: "Word - Tiếng Việt",
    Icon: <Article fontSize="small" />,
  },
  {
    ID: "Excel",
    Form: "TiengAnh",
    Label: "Excel - English",
    LabelEN: "Excel - English",
    Icon: <TableView fontSize="small" />,
  },
  {
    ID: "Excel",
    Form: "TiengViet",
    Label: "Excel - Tiếng Việt",
    LabelEN: "Excel - Tiếng Việt",
    Icon: <TableView fontSize="small" />,
  },
];
//ham filter su dung cho combobox
/*------------------------------------Mot so ham xu ly du lieu --------------------*/
function validate_Data(data, atts) {
  //validate danh sach truong khong duoc trong'
  var ret = myLib.validateFields(
    data,
    [
      "MaCongTy",
      "MaCongTy2"
    ].reduce(
      (obj, item) => Object.assign(obj, { [item]: { allowEmpty: "false" } }),
      {}
    )
  );

  ret.error = Object.keys(ret).length > 0;

  return ret;
}

/*------------------------------------FORM--------------------------------------*/
class PriceQuoteEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSaved: false, //du lieu da tung duoc save hay chua
      DanhMuc: { DM_CongTy: [], DM_HMSC: [] },
      validateStatus: { error: false }, //trang thai validate

      after: {
        MaCongTy: props.edittingRecord.MaCongTy,
        TenCongTy: props.edittingRecord.TenCongTy,
        MaCongTy2: null, //ma cong ty moi khi merge
        TenCongTy2: null,
      },
      Attachs: [],
      _localVersion: 0,
    };
  }

  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps) {
    return { open: nextProps.open };
  }

  componentDidMount() {
    this.loadDanhMuc("DM_CongTy", () => { });
  }

  loadDanhMuc(danhsach, nextFunc) {
    //load danh muc
    if (danhsach) {
      server
        .post("ChiPhi/DoRequest", {
          Function: "Proc_Table_GetAll",
          ThamSo: {
            TableNames: danhsach,
          },
        })
        .then((response) => {
          this.setState(
            {
              DanhMuc: {
                ...this.state.DanhMuc,
                ...response,
              },
            },
            () => nextFunc()
          );
        })
        .catch((error) => {
          showError(error);
          nextFunc();
        });
    }

  }

  saveField = (fieldName, value) => {
    var s = this.state; //new value

    s.after[fieldName] = value;

    s.dataChanged = true;
    this.setState({ saving: false });
  };
  saveData = (obj, callback) => {
    var s = {};
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    s.after = { ...this.state.after, ...obj };
    this.setState(s, () => {
      if (callback) {
        callback();
      }
    });
  };
  saveRecord = (index, value) => {
    var s = { after: { ...this.state.after } }; //new value
    s.after.NoiDung[index] = value;
    s.dataChanged = true;
    this.setState(s);
  };




  doSave = () => {
    try {
      var check = validate_Data(this.state.after, this.state.Attachs);
      if (!check.error) {
        server
          .post("ChiPhi/DoRequest", {
            Function: "Proc_DM_CongTy_Merger",
            ThamSo: {
              ...this.state.after,
            },
          })
          .then(() => {
            this.props.close(true);
          })
          .catch((error) => {
            handleServerError(error);
            this.setState({ saving: false });
          });
      } else {
        this.setState({ validateStatus: check, saving: false });
        showError("Vui lòng kiểm tra các trường đánh dấu đỏ!");
      }
    } catch (error) {
      this.setState({ saving: false });
      handleServerError(error);
    }
  };

  handleClose = () => {
    if (this.state.dataChanged) {
      this.setState({ showConfirmExit: true });
    } else {
      this.props.close(this.state.dataSaved);
    }
  };


  render() {
    const { classes, theme } = this.props;
    return (
      <Dialog
        open={this.props.open}
        maxWidth={"md"}
        fullWidth={true}
        onClose={() => { }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar sx={{ position: "relative" }}>
          <Stack direction="row">
            <Typography
              sx={{ ml: 2, flex: 1, verticalAlign: "center" }}
              variant="h6"
              component="div"
            >
              {formTitle}
            </Typography>
            <Stack direction="row" spacing={4}>
              {this.state.loading_data ? (
                <CircularProgress color="warning" size={24} />
              ) : null}
              {this.state.saving ? (
                <CircularProgress color="inherit" size={24} />
              ) : null}
              {this.state.loading ? (
                <CircularProgress color="primary" size={24} />
              ) : (
                <></>
              )}
              <Button
                color="success"
                variant="contained"
                disabled={!this.state.dataChanged || this.state.saving}
                onClick={() => this.doSave()}
              >
                {buttonLabels.btnSave}
              </Button>
              <Button
                color="success"
                variant="contained"
                disabled={this.state.saving}
                onClick={this.handleClose}
              >
                {buttonLabels.btnClose}
              </Button>
            </Stack>
          </Stack>
        </AppBar>
        <DialogContent>
          <div
            style={{
              minWidth: 800,
              minHeight: 30,
              padding: 2,
              fontSize: 10,
              wordWrap: "break-word",
              overflow: "hidden",
            }}
          >


            <Grid container columns={24} rowSpacing={4} columnSpacing={1}>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.MaCongTy}</FormLabel>
              </Grid>
              <Grid item xs={20}>
                <OutlinedInput
                  fullWidth
                  readOnly
                  value={this.props.edittingRecord.TenCongTy}
                />
              </Grid>
              <Grid item xs={24}>
                <FormLabel
                   sx={{ color: "red" }}
                >
                  <b>WARNING: BE CARE FULL !!!</b>
                </FormLabel>
              </Grid>
              <Grid item xs={4}>
                <FormLabel
                  onClick={() =>
                    this.setState({
                      show_thongtin_field: true,
                      Show_FieldName: "MaCongTy2",
                    })
                  }
                >
                  {fieldLabels.MaCongTy2}
                </FormLabel>
              </Grid>

              <Grid item xs={20}>
                <MySelectFilter
                  fullWidth
                  options={this.state.DanhMuc.DM_CongTy}
                  optionValue="MaCongTy"
                  optionLabel="TenCongTy"
                  placeholder="Select contractor"
                  value={{
                    MaCongTy: this.state.after.MaCongTy2,
                    TenCongTy: this.state.after.TenCongTy2,
                  }}
                  onChange={(item) => {
                    this.saveData({
                      MaCongTy2: item ? item.MaCongTy : null,
                      TenCongTy2: item ? item.TenCongTy : null,
                    });
                  }}
                  error={this.state.validateStatus.MaCongTy2 !== undefined}
                />
              </Grid>


            </Grid>


          </div>
        </DialogContent>

        <ToastContainer
          position="top-right"
          autoClose={false}
          hideProgressBar
          newestOnTop={true}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
          style={{ fontSize: 12, width: 750 }}
          limit={5}
        />
        <SimpleDialog
          confirm
          message="Bạn chắc chắn muốn thoát ra ?"
          open={this.state.showConfirmExit}
          close={(ok) => {
            this.setState({ showConfirmExit: false });
            if (ok) {
              this.props.close(this.state.dataSaved);
            }
          }}
        />
        {this.state.show_thongtin_field ? (
          <FieldNameDialog
            open={true}
            FormName="PriceQuoteEditDialog"
            ListFields={listFields}
            FieldName={this.state.Show_FieldName}
            close={() => {
              this.setState({ show_thongtin_field: false });
            }}
          />
        ) : null}
      </Dialog>
    );
  }
}
export default withStyles(formStyles, { withTheme: true })(
  PriceQuoteEditDialog
);
